// extracted by mini-css-extract-plugin
module.exports = {"sliderHeader":"style_sliderHeader__2XcWR"};